<template>
  <v-container
    class="
      m-search-bar-container
      d-flex
      pa-0
      mr-10
      align-center align-self-center align-content-center
    "
  >
    <v-text-field
      ref="search"
      v-model="keyword"
      placeholder="Search"
      clearable
      outlined
      dense
      hide-details
      prepend-inner-icon="mdi-magnify"
      @click:clear="clearSearch"
      @blur="onSearchBlur"
      @focus="onSearchFocus"
      @keyup.enter="submitSearch"
      @keyup="onSearchKeyup"
      :disabled="isDisabled"
    />
  </v-container>
</template>
<script>
export default {
  name: "MSearchBar",
  data() {
    return {
      keyword: "",
      isDisabled: false,
    };
  },
  watch: {
    $route (to, from) {
      this.setSearchText()
      this.enableDisableSearch()
    }, 
  },
  methods: {
    setSearchText() {
      if (!this.$route.query.name) {
        this.keyword = "";
      } else {
        this.keyword = this.$route.query.name;
      }
    },
    clearSearch: function () {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.$emit("event");
      }

      this.keyword = "";
      let query = { ...this.$route.query };
      if (query.name) {
        delete query.name;
        delete query.search;
        this.$router.replace({ query,params: {...this.$route.params} });
      }
      this.$refs.search.blur();
    },
    submitSearch() {
      /** Initial Values */
      let {accountId} = this.$route.params
      let query = {
        ...this.$route.query,
        name: this.keyword,
        search: "true"
      }
      /** Find Path on basis route meta */
      let search = this.$route.meta.search
      if(!search){
        search = {
          name: this.$route.name
        }
      }
      else if("path" in search && (!("absolute" in search) || !search.absolute)){
        /** Add accountId for relative path  */
        let path = search.path;
        if(!path.startsWith('/')){
          path = `/${path}`;
        }
        if(!path.startsWith(`/accounts/${accountId}`) && process.env.VUE_APP_PRODUCT == 'Marketing'){
          path = `/accounts/${accountId}${path}`;
        }
        search.path = path;
      }
      
      /** add query params */
      search.query = query
      search.params = {...this.$route.params}
      this.$router.push(search);
    },
    onSearchFocus() {
      this.isOutlined = true;
    },
    onSearchBlur() {
      this.isOutlined = false;
    },
    onSearchKeyup() {
      return this.keyword === "" ? this.clearSearch() : false;
    },
    enableDisableSearch() {
      this.isDisabled = false;
      if (
        "meta" in this.$route &&
        "search" in this.$route.meta &&
        this.$route.meta.search === false
      ) {
        this.isDisabled = true;
      }
    },
  },
};
</script>

